import { useNavigate } from 'react-router-dom'
import { ChevronRight, Link2, Search, Tag } from 'lucide-react'
import { PageContainer } from '@/components/common/PageContainer'
import { RfidAppHeader } from '@/components/rfid/RfidAppHeader'
import { BRAND } from '@/constants/brand'
import { useLocale } from '@/i18n/LocaleProvider'
import { cn } from '@/utils/cn'

const MODULES = [
  {
    to: '/engine/birth',
    icon: Tag,
    titleKey: 'birthTitle' as const,
    subKey: 'birthSubtitle' as const,
  },
  {
    to: '/engine/tag',
    icon: Link2,
    titleKey: 'tagTitle' as const,
    subKey: 'tagSubtitle' as const,
  },
  {
    to: '/engine/lookup',
    icon: Search,
    titleKey: 'lookupTitle' as const,
    subKey: 'lookupSubtitle' as const,
  },
]

export default function EngineHubPage() {
  const navigate = useNavigate()
  const { t } = useLocale()

  return (
    <PageContainer fluid className="!flex !h-full !min-h-0 !flex-col !px-0 !py-0" stack={false}>
      <div className="rfid-web-frame">
        <RfidAppHeader
          title={t.Engine?.hubTitle ?? 'RFID Engine'}
          subtitle={t.Engine?.hubSubtitle ?? 'Birth, tag, and look up LEAP RFID ↔ SKU mappings'}
          onBack={() => navigate('/')}
        />

        <div className="rfid-wizard-body !flex !min-h-0 !flex-1 !flex-col !gap-3 !overflow-auto">
          <div className="rfid-section-label">{t.Engine?.modules ?? 'MODULES'}</div>
          {MODULES.map(({ to, icon: Icon, titleKey, subKey }) => (
            <button
              key={to}
              type="button"
              onClick={() => navigate(to)}
              className={cn(
                'flex w-full items-center gap-3.5 rounded-2xl border-[1.5px] border-border',
                'bg-card px-4 py-4 text-left shadow-sm transition-opacity hover:opacity-95'
              )}
            >
              <span
                className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[14px]"
                style={{ background: `${BRAND}14`, color: BRAND }}
              >
                <Icon className="h-5 w-5" strokeWidth={2} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-[15px] font-black text-foreground">
                  {t.Engine?.[titleKey] ?? titleKey}
                </span>
                <span className="mt-1 block text-xs font-semibold text-muted-foreground">
                  {t.Engine?.[subKey] ?? ''}
                </span>
              </span>
              <ChevronRight className="h-5 w-5 shrink-0" style={{ color: BRAND }} strokeWidth={2.5} />
            </button>
          ))}
        </div>
      </div>
    </PageContainer>
  )
}
